import React, { useState } from 'react';
import { Carousel } from 'antd';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';

// 自定义箭头组件 - 过滤掉 Carousel 传递的非 DOM 属性
const CustomArrow: React.FC<{
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  direction: 'left' | 'right';
  // 以下属性会被 Carousel 传递，但我们不使用它们
  currentSlide?: number;
  slideCount?: number;
}> = ({ className, style, onClick, direction }) => (
  <div
    className={className}
    style={style}
    onClick={onClick}
  >
    <div className="custom-arrow-container">
      {direction === 'left' ? (
        <ChevronLeftIcon size={20} strokeWidth={2} />
      ) : (
        <ChevronRightIcon size={20} strokeWidth={2} />
      )}
    </div>
  </div>
);

export interface ImageCarouselProps {
  images: string[];
  height?: number | string;
  showCounter?: boolean;
  counterPosition?: 'top-right' | 'bottom-center';
  className?: string;
  style?: React.CSSProperties;
}

/**
 * 共享的图片轮播组件
 * 用于 PostDetailModal 中展示多张图片
 */
export const ImageCarousel: React.FC<ImageCarouselProps> = ({
  images,
  height = '100%',
  showCounter = true,
  counterPosition = 'top-right',
  className = '',
  style,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (images.length === 0) {
    return (
      <div 
        className={`carousel-container carousel-empty ${className}`}
        style={{ height, ...style }}
      >
        暂无图片
      </div>
    );
  }

  return (
    <div 
      className={`carousel-container ${className}`}
      style={{ height, ...style }}
    >
      <Carousel
        autoplay={false}
        arrows
        dots={{ className: 'custom-dots' }}
        prevArrow={<CustomArrow direction="left" />}
        nextArrow={<CustomArrow direction="right" />}
        style={{ height: '100%' }}
        afterChange={(current) => setCurrentIndex(current)}
      >
        {images.map((img, index) => (
          <div key={index} className="carousel-slide">
            <div className="carousel-slide-inner">
              <img
                src={img}
                alt={`图片 ${index + 1}`}
                className="carousel-image"
              />
            </div>
          </div>
        ))}
      </Carousel>
      
      {/* 图片数量指示器 */}
      {showCounter && images.length > 1 && (
        <div className={`carousel-counter carousel-counter-${counterPosition}`}>
          第 {currentIndex + 1}/{images.length} 张
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;
